import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { render } from 'react-dom'
import { loadPortalConfig, showConfigErrorScreen, showAppErrorScreen, isChunkLoadError } from './api/portalConfigLoader'
import * as portalConfig from './api/portalConfig'

const CHUNK_RETRY_KEY = 'btv_chunk_retry' // one-shot sessionStorage guard - prevents reload loops if the bundle is genuinely broken

// fetch config and dynamic-import Wrapper so React-tree module-level imports see post-init live bindings
loadPortalConfig()
    .then(async () => {
        try {
            const { default: Wrapper } = await import('./components/Wrapper')
            document.title = portalConfig.TITLE || "Portal"
            render(<Wrapper />, document.getElementById('root'))
            try { sessionStorage.removeItem(CHUNK_RETRY_KEY) } catch {} // clear the guard on first successful render after a recovery
        } catch (err) {
            // chunk/render errors auto-reload once or fall through to showAppErrorScreen
            if (isChunkLoadError(err) && !sessionStorage.getItem(CHUNK_RETRY_KEY)) { // stale index.html after a deploy - force one reload to fetch fresh chunk hashes
                try { sessionStorage.setItem(CHUNK_RETRY_KEY, '1') } catch {}
                window.location.reload()
                return
            }
            showAppErrorScreen(err)
        }
    })
    .catch(showConfigErrorScreen) // config-fetch error
